import intl from "../services/intl";
import { productPromotionTranslationKeysFor } from "../data/product-promotion/product-promotion";

export function productPromotionPrice(sku) {
  const productTranslationKeys = productPromotionTranslationKeysFor(sku);
  const priceLocale = intl.t(productTranslationKeys.price);

  return (priceLocale / 100).toFixed(2);
}
